<mat-form-field>
  <mat-select [placeholder]="'Select a Location Set Type'">
    @for (option of locationSetTypes$ | async; track option) {
      <mat-option
        (click)="handleLocationSetTypeClick(option)"
      [value]="option">{{ option.name }}</mat-option>
    }
  </mat-select>
</mat-form-field>
